// Angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes , ExtraOptions } from '@angular/router';
import { ApiService } from './service/api.service';
import { LoadingService } from './service/loading.service';

//import { PopService } from './service/pop.service';

// Modal Component
//import { PopComponent } from './pop/pop.component'
//Component
import {LeftSelectComponent} from './component/leftSelect.component';
import {ActSelectComponent} from './component/actSelect.component';
import {BuyerSelectComponent} from './component/buyerSelect.component';
import {PaginationComponent} from './component/pagination.component';
import {buyerCardComponent} from './component/buyerCard.component';
import {eventItemComponent} from './component/eventItem.component';
import {eventCardComponent} from './component/eventCard.component';
import {CookieBoxComponent} from './component/cookiebox.component';
import {GmapComponent} from './component/gmap.component';
import {EmptyComponent} from './component/empty.component';
// Directuve
import { UrlHrefDirective } from '../share/directive/hrefDirective';
import { PipeModule } from '../../app/share/pipe/pipe.module';
@NgModule({
  imports: [
    CommonModule,
    //ModalModule,
    FormsModule,
    PipeModule,
    RouterModule
  ],
  declarations: [
    LeftSelectComponent,
    ActSelectComponent,
    BuyerSelectComponent,
    PaginationComponent,
    buyerCardComponent,
    eventItemComponent,
    eventCardComponent,
    GmapComponent,
    EmptyComponent,
    CookieBoxComponent,
    UrlHrefDirective
  ],
  providers: [
    ApiService,
    LoadingService,
  ],
  exports: [
    LeftSelectComponent,
    ActSelectComponent,
    BuyerSelectComponent,
    PaginationComponent,
    buyerCardComponent,
    eventItemComponent,
    eventCardComponent,
    CookieBoxComponent,
    GmapComponent,
    EmptyComponent,
    UrlHrefDirective,
    PipeModule
  ]
})
export class ShareModule { }
